import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Sparkles, Users, Link2, Compass } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const freePerks = [
  { icon: Compass, text: "Browse The Plaza & filters" },
  { icon: Users, text: "Join any hosted study" },
  { icon: Check, text: "Prayer, messages & check-in" },
];
const curatorPerks = [
  { icon: Sparkles, text: "Create & curate your own studies" },
  { icon: Link2, text: "Invite close friends by private link" },
  { icon: Users, text: "Host toolkit: attendance & messaging" },
  { icon: Check, text: "Everything in Free" },
];

export default function Upgrade() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);

  const isCurator = user?.tier === "curator";

  const checkout = async () => {
    if (!user) return nav("/auth");
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", { lookup_key: "curator_monthly", origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6">
      <div className="text-center">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-[#F36353]/12 px-3 py-1.5 text-xs font-semibold text-[#D94A3D]"><Sparkles size={13} /> Curator plan</span>
        <h1 className="mt-3 font-display text-3xl font-bold tracking-tight text-[#0F3D66] sm:text-4xl">Start your own study table</h1>
        <p className="mt-2 text-[#6B6763]">Upgrade to create studies, curate your group and invite friends.</p>
      </div>

      <div className="mt-8 grid gap-5 sm:grid-cols-2">
        <div className="rounded-3xl border border-[#E8E4DF] bg-white p-6">
          <h2 className="font-display text-lg font-semibold text-[#0F3D66]">Free</h2>
          <div className="mt-1 font-display text-3xl font-bold text-[#0F3D66]">$0</div>
          <ul className="mt-4 space-y-2.5">
            {freePerks.map((p, i) => { const I = p.icon; return (
              <li key={i} className="flex items-center gap-2 text-sm text-[#6B6763]"><I size={16} className="text-[#748C70]" /> {p.text}</li>
            ); })}
          </ul>
          <div className="mt-6 rounded-full border border-[#E8E4DF] py-2.5 text-center text-sm font-medium text-[#6B6763]">Your current plan{!isCurator ? "" : ""}</div>
        </div>

        <div className="relative rounded-3xl border-2 border-[#F36353] bg-white p-6 bp-card-shadow">
          <span className="absolute -top-3 left-6 rounded-full bg-[#F36353] px-3 py-1 text-xs font-semibold text-white">Recommended</span>
          <h2 className="font-display text-lg font-semibold text-[#0F3D66]">Curator</h2>
          <div className="mt-1 font-display text-3xl font-bold text-[#0F3D66]">$4.99<span className="text-base font-medium text-[#6B6763]">/month</span></div>
          <ul className="mt-4 space-y-2.5">
            {curatorPerks.map((p, i) => { const I = p.icon; return (
              <li key={i} className="flex items-center gap-2 text-sm text-[#0F3D66]"><I size={16} className="text-[#F36353]" /> {p.text}</li>
            ); })}
          </ul>
          {isCurator ? (
            <div className="mt-6 flex items-center justify-center gap-1.5 rounded-full bg-[#748C70]/15 py-2.5 text-center text-sm font-semibold text-[#4f6a4b]"><Check size={16} /> You're a Curator</div>
          ) : (
            <Button onClick={checkout} disabled={loading} data-testid="upgrade-checkout-btn" className="mt-6 h-11 w-full rounded-full bg-[#F36353] text-white hover:bg-[#D94A3D]">
              {loading ? "Redirecting…" : "Upgrade to Curator"}
            </Button>
          )}
          <p className="mt-3 text-center text-xs text-[#9c9791]">Stripe test mode · card 4242 4242 4242 4242</p>
        </div>
      </div>
    </div>
  );
}
